import React, {useEffect, useState} from "react";
import {groupSongsByISRC, getDistancesBetweenSongs, playlistTime} from "../utils/PlaylistHelper";

export function PlaylistChecker({playlist}) {

    let emptyPlaylistStats = {
        length: 0,
        uniqueSongs: 0,
        duration: "00:00",
        minDistanceBetweenSongs: Math.nan,
        occurrences:[],
        deltasByISRC: [],
    }
    const [playlistStats, setPlaylistStats] = useState(emptyPlaylistStats);

    useEffect(() => {
        // to be 100% sure playlist is not modified
        let _playlist = [...playlist];
        if(_playlist.length > 0) {
            let deltas = getDistancesBetweenSongs(_playlist);
            let stats = {
                length: _playlist.length,
                duration: playlistTime(_playlist),
                occurences: groupSongsByISRC(_playlist),
                deltasByISRC: deltas.deltasByISRC,
            };
            stats.uniqueSongs = Object.keys(stats.occurences).length;
            stats.minDistanceBetweenSongs = Math.min(...deltas.allDeltas);
            setPlaylistStats(stats);
        } else {
            setPlaylistStats(emptyPlaylistStats);
        }
    }, [playlist])

    const getMinDistItem = () => {
        let minDist = playlistStats.minDistanceBetweenSongs;
        if(minDist < 2){
            return(<td style={{background: 'red'}}>{minDist}</td>);
        } else {
            return(<td>{minDist}</td>);
        }
    };

    return(
        <table>
            <tbody>
            <tr>
                <td>Length</td>
                <td>{playlistStats.duration}</td>
            </tr>
            <tr>
                <td>Number of Songs</td>
                <td>{playlistStats.length} songs / {playlistStats.uniqueSongs} unique</td>
            </tr>
            <tr>
                <td>Min distance between same songs</td>
                { getMinDistItem() }
            </tr>
            </tbody>
        </table>
    )

}